// Existing patient documents can store either a numeric legacy type ID or a
// Firestore document ID, under several field names used by past writers.
export function documentTypeForRecord(documentTypes, documentData) {
  if (!Array.isArray(documentTypes) || !documentData) return null;

  const candidates = [
    documentData.typeId,
    documentData.docTypeId,
    documentData.documentTypeId,
    documentData.docType,
  ].filter((id) => id !== undefined && id !== null && id !== "");

  for (const candidate of candidates) {
    const key = String(candidate);
    const match = documentTypes.find((type) =>
      [type.id, type.legacyId, type.firestoreId]
        .some((id) => id !== undefined && id !== null && String(id) === key)
    );
    if (match) return match;
  }
  return null;
}
